var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.436035C11.366 0.436035 14.5 3.57004 14.5 7.43604C14.5 11.302 11.366 14.436 7.5 14.436C3.63401 14.436 0.5 11.302 0.5 7.43604C0.5 3.57004 3.63401 0.436035 7.5 0.436035ZM7.5 1.31104C4.11726 1.31104 1.375 4.05329 1.375 7.43604C1.375 10.8188 4.11726 13.561 7.5 13.561C10.8827 13.561 13.625 10.8188 13.625 7.43604C13.625 4.05329 10.8827 1.31104 7.5 1.31104ZM7.94014 10.061L8.37544 11.3741H6.625L7.06152 10.061H7.94014ZM8.375 3.49854L7.93928 9.18604H7.0625L6.625 3.49854H8.375Z",
    fill: "#303C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5f34d2249017295501a26bf11ddf2c6c.svg";
export { ForwardRef as ReactComponent };